import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./PositionReportUSA.css";
import { useEffect, useState } from "react";
import { numToDecimalString, numToCurrency, currencyToNum } from "./utils/transformators";
import moment from "moment";
import { stgpmtcalc } from "./utils/calculations";
import useUSPosition from "../../hooks/useUSPosition";
import USPosMatchingToolTip from "./USPosMatchingToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import USPosPriceToolTip from "./USPosPriceToolTip";

const PositionReportUSA = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  // Context Values
  const { positiontoedit, setPositiontoedit } = useUSPosition();
  // States
  const [gdata, setGdata] = useState();
  const [usposmatchnumber, setUSposmatchnumber] = useState();
  const [datalength, setDatalength] = useState();
  const [usposmatch, setUSposmatch] = useState(0);
  const [mktpricedata, setMktpricedata] = useState();

  // function to group data
  // eslint-disable-next-line no-extend-native
  Array.prototype.groupBy = function (key) {
    return this.reduce(function (groups, item) {
      const val = item[key];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };

  // load data
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axiosPrivate.get("/api/positions/loaduspositionreport");
        setDatalength(response.data.length);
        setGdata(response.data.groupBy("productGroup"));
      } catch (err) {
        // console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    fetchdata();
  }, []);

  // Hooks
  useEffect(() => {
    const fetchdata = async () => {
      const response = await axiosPrivate.post("/api/positions/loadusmktpriceupdates");
      // console.log(response.data);
      setMktpricedata(response.data);
    };
    fetchdata();
  }, []);

  // Navigate to selected US position
  // navigate to positionsUSA and send navpostoedit to load it
  const handleNavToUSPos = (posID) => {
    console.log("id", posID);
    navigate("/positions/usa", { state: { positiontoedit: posID } });
    // setPositiontoedit(posID);
  };

  const handleMktPriceValue = (id) => {
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.USposID === id;
      });
      if (result[0]) {
        return numToCurrency(result[0]["mktpriceupdate"]);
      } else {
        return "N/A";
      }
    }
  };

  const handleMktValue = (id, inv) => {
    // console.log(id, inv);
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.USposID === id;
      });
      if (result[0]) {
        return numToCurrency(result[0]["mktpriceupdate"] * inv, 0);
      } else {
        return "N/A";
      }
    }
  };

  const handlePProfit = (id, inv, pr, stg) => {
    if (mktpricedata) {
      let result = mktpricedata.filter((item) => {
        return item.USposID === id;
      });
      if (result[0]) {
        return numToCurrency(
          (result[0]["mktpriceupdate"] - Number(pr.toFixed(2).replace(/[^0-9.-]+/g, "")) - stg) * inv,
          // result[0]["mktpriceupdate"] * inv - inv * Number(pr.toFixed(2).replace(/[^0-9.-]+/g, "")),
          0
        );
      } else {
        return "N/A";
      }
    }
  };

  var group = "";
  var prod = {};
  var u = 0;
  var uplts = 0;
  var prof = 0;
  var currval = 0;
  var sumu = 0;
  var sumuplts = 0;
  var sumcurrval = 0;
  var ind = 0;
  var ttlmktval = 0;
  var ttlprof = 0;

  return (
    <div className='uspositionreport'>
      {/* <table id='uspositionreporttable'>
        <thead>
          <tr>
            <th>USWGP</th>
            <th className='fig'>Quantity</th>
            <th className='fig'>Inventory</th>
            <th className='fig'>In Pallets</th>
            <th>Warehouse</th>
            <th className='fig'>EW Price</th>
            <th className='fig'>Storage</th>
            <th>Supplier</th>
            <th style={{ minWidth: "50px" }}>From</th>
            <th style={{ minWidth: "50px" }}>To</th>
            <th className='fig'>CostValue</th>
            <th className='fig'>MktPrice</th>
            <th className='fig'>MktValue</th>
            <th className='fig'>PProfit</th>
          </tr>
        </thead>
        <tbody>
          {gdata &&
            Object.entries(gdata).map((i, key) => {
              group = Object.keys(gdata)[key];
              prod = gdata[group].groupBy("product");
              return [
                <tr>
                  <td className='usprodgroup' style={{ paddingTop: "1rem" }} colSpan={14}>
                    <p>{group}</p>
                  </td>
                </tr>,
                Object.entries(prod).map((j, k) => {
                  u = 0;
                  uplts = 0;
                  prof = 0;
                  currval = 0;
                  return [
                    <tr>
                      <td className='usproduct' style={{ borderBottom: "1px solid black" }} colSpan={14}>
                        <h4>{Object.keys(prod)[k]}</h4>
                      </td>
                    </tr>,
                    j[1].map((x) => {
                      u = u + Number(x.inventory);
                      uplts = uplts + Number(x.inventoryPallets);
                      const daysInStorage = Math.max(
                        moment().diff(moment(x.whentrydate, "YYYY-MM-DD"), "days") - x.whgraceperiod,
                        0
                      );
                      currval =
                        currval +
                        x.inventory *
                          (x.EWPrice +
                            stgpmtcalc(
                              daysInStorage,
                              x.whfixedcost,
                              x.whvarcost,
                              x.quantity,
                              x.numpallets,
                              x.whaccrualperiod
                            ));
                      return (
                        <>
                          <tr>
                            <td>{x.WGP}</td>
                            <td className='fig'>{numToDecimalString(x.quantity)}</td>
                            <td className='fig'>{numToDecimalString(x.inventory)}</td>
                            <td className='fig'>{numToDecimalString(x.inventoryPallets)}</td>
                            <td>{x.warehouse}</td>
                            <td className='fig'>{numToCurrency(x.EWPrice)}</td>
                            <td>
                              {numToCurrency(
                                stgpmtcalc(
                                  daysInStorage,
                                  x.whfixedcost,
                                  x.whvarcost,
                                  x.quantity,
                                  x.numpallets,
                                  x.whaccrualperiod
                                )
                              )}
                            </td>
                            <td>{x.supplier}</td>
                            <td className='fig'>{moment(x.shipfrom).format("DD-MMM").toString()}</td>
                            <td className='fig'>{moment(x.shipuntil).format("DD-MMM").toString()}</td>
                            <td className='fig'>
                              {numToCurrency(
                                x.inventory *
                                  (x.EWPrice +
                                    stgpmtcalc(
                                      daysInStorage,
                                      x.whfixedcost,
                                      x.whvarcost,
                                      x.quantity,
                                      x.numpallets,
                                      x.whaccrualperiod
                                    )),
                                0
                              )}
                            </td>
                          </tr>
                        </>
                      );
                    }),
                    <tr className='usposreporttotals'>
                      <td colSpan={2}>
                        <h4>Total</h4>
                      </td>
                      <td className='fig'>
                        <h4>{numToDecimalString(u)}</h4>
                      </td>
                      <td className='fig'>
                        <h4>{numToDecimalString(uplts)}</h4>
                      </td>
                      <td colSpan={6}></td>
                      <td className='fig'>
                        <h4>{numToCurrency(currval, 0)}</h4>
                      </td>
                    </tr>,
                  ];
                }),
              ];
            })}
        </tbody>
      </table> */}
      <div className='uspositionreport-header'>
        <div style={{ textAlign: "left", flexBasis: 0 }}>USWGP</div>
        <div className='fig'>Quantity</div>
        <div className='fig'>Inventory</div>
        <div className='fig'>In Pallets</div>
        <div className='fig'>Warehouse</div>
        <div className='fig'>Cost</div>
        <div className='fig'>Storage</div>
        <div className='fig'>COGS</div>
        <div className='fig'>Supplier</div>
        {/* <div className='fig'>From</div> */}
        <div className='fig'>WH Entry</div>
        <div className='fig'>COGSValue</div>
        <div className='fig'>MktPrice</div>
        <div className='fig'>MktValue</div>
        <div className='fig'>PProfit</div>
      </div>
      {/* Body */}
      <div className='uspositionreport-body'>
        {gdata &&
          Object.entries(gdata).map(([groupName, groupData]) => {
            const products = groupData.groupBy("product");
            return (
              <div key={groupName} className='usposition-group'>
                <div className='usprodgroup'>{groupName}</div>
                {Object.entries(products).map(([productName, productItems]) => {
                  let u = 0;
                  let uplts = 0;
                  let currval = 0;
                  let prodttlmktval = 0;
                  let prodttlprft = 0;
                  return (
                    <div key={productName} className='usproduct-block'>
                      <div className='usproduct'>{productName}</div>
                      {productItems.map((x, i) => {
                        sumu += Number(x.inventory);
                        u += Number(x.inventory);
                        uplts += Number(x.inventoryPallets);
                        sumuplts += Number(x.inventoryPallets);
                        ind += 1;
                        const daysInStorage = Math.max(
                          moment().diff(moment(x.whentrydate, "YYYY-MM-DD"), "days") - x.whgraceperiod,
                          0
                        );
                        const stg = stgpmtcalc(
                          daysInStorage,
                          x.whfixedcost,
                          x.whvarcost,
                          x.quantity,
                          x.numpallets,
                          x.whaccrualperiod
                        );
                        currval += x.inventory * (x.EWPrice + stg);
                        sumcurrval += x.inventory * (x.EWPrice + stg);
                        let mktval = handleMktValue(x.USposID, x.inventory);
                        if (mktval && mktval !== "N/A") {
                          ttlmktval = ttlmktval + currencyToNum(mktval);
                          prodttlmktval = prodttlmktval + currencyToNum(mktval);
                        }
                        let prft = handlePProfit(x.USposID, x.inventory, x.EWPrice, stg);
                        if (prft && prft !== "N/A") {
                          ttlprof = ttlprof + currencyToNum(prft);
                          prodttlprft = prodttlprft + currencyToNum(prft);
                        }
                        return (
                          <div key={i} className='usposition-row'>
                            <div style={{ position: "relative", textAlign: "left", flexBasis: 0 }}>
                              <div
                                onMouseEnter={() => setUSposmatchnumber(x.WGP)}
                                onMouseLeave={() => setUSposmatchnumber(0)}
                                onClick={() => handleNavToUSPos(x.USposID)}
                                style={{ color: "var(--blue)", flexBasis: 0 }}
                              >
                                {x.WGP}{" "}
                              </div>
                              <USPosMatchingToolTip
                                listlength={datalength}
                                itemindex={datalength - ind}
                                usposnumber={x.WGP}
                                usposmatchnumber={usposmatchnumber}
                                url='usposmatching'
                              />
                            </div>
                            <div className='fig'>{numToDecimalString(x.quantity)}</div>
                            <div className='fig'>{numToDecimalString(x.inventory)}</div>
                            <div className='fig'>{numToDecimalString(x.inventoryPallets)}</div>
                            <div className='fig'>{x.warehouse}</div>
                            <div className='fig'>{numToCurrency(x.EWPrice)}</div>
                            <div className='fig'>{numToCurrency(stg)}</div>
                            <div className='fig'>{numToCurrency(x.EWPrice + stg)}</div>
                            <div className='fig'>{x.supplier}</div>
                            {/* <div className='fig'>{moment(x.shipfrom).format("DD-MMM")}</div> */}
                            <div className='fig'>{moment(x.whentrydate).format("DD-MMM")}</div>
                            <div className='fig'>{numToCurrency(x.inventory * (x.EWPrice + stg), 0)}</div>
                            <div className='mktpriceupdate fig' style={{ position: "relative", flexDirection: "row" }}>
                              <FontAwesomeIcon
                                style={{ marginRight: "5px" }}
                                onClick={(e) => {
                                  if (x.USposID === usposmatch) {
                                    setUSposmatch(0);
                                  } else {
                                    setUSposmatch(x.USposID);
                                  }
                                }}
                                icon={faPlusCircle}
                              />{" "}
                              <USPosPriceToolTip
                                usposid={x.USposID}
                                usposmatch={usposmatch}
                                setUSposmatch={setUSposmatch}
                                setMktpricedata={setMktpricedata}
                                url1='addusmktprice'
                                url2='loadusmktpriceupdates'
                              />
                              {handleMktPriceValue(x.USposID)}
                            </div>
                            <div className='fig'>{handleMktValue(x.USposID, x.inventory)}</div>
                            <div className='fig'>{handlePProfit(x.USposID, x.inventory, x.EWPrice, stg)}</div>
                          </div>
                        );
                      })}

                      <div className='usposreporttotals usposition-row'>
                        <div style={{ flexBasis: 0 }}></div> {/* USWGP */}
                        <div></div> {/* Quantity */}
                        <div className='fig'>{numToDecimalString(u)}</div> {/* Inventory total */}
                        <div className='fig'>{numToDecimalString(uplts)}</div> {/* In Pallets total */}
                        <div></div> {/* Warehouse */}
                        <div></div> {/* EW Price */}
                        <div></div> {/* Storage */}
                        <div className='fig'>{numToCurrency(currval / u, 2)}</div> {/* EW Price */}
                        <div></div> {/* Supplier */}
                        {/* <div></div> From */}
                        <div></div> {/* To */}
                        <div className='fig'>{numToCurrency(currval, 0)}</div> {/* CostValue total */}
                        <div></div>
                        <div className='fig'>{numToCurrency(prodttlmktval, 0)}</div>
                        <div className='fig'>{numToCurrency(prodttlprft, 0)}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
      <div className='usposreporttotals usposition-row'>
        <div style={{ textAlign: "left", flexBasis: 0 }}>TOTAL:</div> {/* USWGP */}
        <div></div> {/* Quantity */}
        <div className='fig'>{numToDecimalString(sumu)}</div>
        <div className='fig'>{numToDecimalString(sumuplts)}</div>
        <div></div> {/* Warehouse */}
        <div></div> {/* Cost*/}
        <div></div> {/* Storage */}
        <div></div> {/* COGS*/}
        <div></div> {/* Supplier */}
        {/* <div></div> From */}
        <div></div> {/* To */}
        <div className='fig'>{numToCurrency(sumcurrval, 0)}</div> {/* CostValue total */}
        <div></div> {/* To */}
        <div className='fig'>{numToCurrency(ttlmktval, 0)}</div>
        <div className='fig'>{numToCurrency(ttlprof, 0)}</div>
      </div>
    </div>
  );
};

export default PositionReportUSA;
